module.exports = __webpack_public_path__ + "img/document.93b4edd1.svg";